import cn from 'classnames';
import { AnimatePresence, motion } from 'framer-motion';
import { useMemo } from 'react';
import { matchPath, useLocation, useNavigate } from 'react-router';
import { tailwindConfig } from 'tailwind-config';

import { ROUTE_PATHS } from 'shared/consts/routes';
import { useTypedSelector } from 'store';

import { AccountsIcon } from 'assets/icons/AccountsIcon';

const Accounts = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const isSidebarOpened = useTypedSelector(store => store.ui.isSidebarOpened);

  const accountsPathIsActive: boolean = useMemo(
    () => Boolean(matchPath(`${ROUTE_PATHS.accounts}/*`, pathname)),
    [pathname],
  );

  return (
    <div
      className={cn('mm-sidebar__menu__item', { _active: accountsPathIsActive })}
      onClick={() => {
        navigate(ROUTE_PATHS.accounts);
      }}
    >
      <div className="mm-sidebar__menu__item__left">
        <div className="mm-sidebar__menu__item__icon">
          <AccountsIcon
            color={accountsPathIsActive ? tailwindConfig.theme.colors.primary : undefined}
          />
        </div>
        <AnimatePresence>
          {isSidebarOpened && (
            <motion.span
              exit={{ opacity: 0, width: 0 }}
              transition={{ duration: isSidebarOpened ? 0.25 : 0 }}
              className="mm-sidebar__menu__item__text"
            >
              Accounts
            </motion.span>
          )}
        </AnimatePresence>
      </div>
    </div>
  );
};

export { Accounts };
